import useTranslations from '@snowball-tech/common/hooks/useTranslations'
import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { UilSearchAlt as SearchIcon } from '@tooni/iconscout-unicons-react'
import dynamicImport from 'next/dynamic'

import { useCallback, useState } from 'react'

import debounce from 'lodash/fp/debounce'

const MobileSearchPanel = dynamicImport(() => import('./MobileSearchPanel'), {
  ssr: false,
})

type Props = {
  onSearch: (query: string, from: 'button' | 'change' | 'keyboard') => void
  searchOnChange?: boolean
  searchOnClear?: boolean
  value?: string
  withUrlParams?: boolean
}
export default function MobileSearch({
  onSearch,
  searchOnChange = true,
  searchOnClear = true,
  value,
  withUrlParams = true,
}: Props) {
  const $t = useTranslations()

  const [isMobileSearchVisible, setIsMobileSearchVisible] = useState(false)
  const hideMobileSearch = useCallback(
    () => setIsMobileSearchVisible(false),
    [],
  )
  const toggleMobileSearch = () =>
    setIsMobileSearchVisible(
      (wasMobileSearchVisible) => !wasMobileSearchVisible,
    )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedOnSearch = useCallback(debounce(250, onSearch), [onSearch])

  return (
    <div className="md:hidden">
      <Button
        icon={<SearchIcon />}
        iconOnly
        label={$t('editions.list.search.button.label')}
        onClick={toggleMobileSearch}
      />

      <MobileSearchPanel
        hide={hideMobileSearch}
        searchOnChange={searchOnChange}
        searchOnClear={searchOnClear}
        toggle={toggleMobileSearch}
        value={value}
        visible={isMobileSearchVisible}
        withUrlParams={withUrlParams}
        onSearch={debouncedOnSearch}
      />
    </div>
  )
}
